import { Tabs, Divider } from 'antd';
import { useParams } from 'react-router-dom/cjs/react-router-dom';
import { PicCenterOutlined,PicRightOutlined ,RocketOutlined} from '@ant-design/icons';
import JobsInFeedBlock from './JobsInFeedBlock';
import JobsOverride from './JobsOverride';
import JobBoostSupplierContract from './jobboost/JobBoostSupplierContract';
import { trackPageAccess } from '../globalFunctions/GlobalFunctions';
import { useContext, useEffect } from 'react';
import { CommonContext } from '../Context';
const { TabPane } = Tabs;

const JobsInfeedOverrideTabs = (props) => {
  const { supplierId } = useParams();
  const commonContext=useContext(CommonContext);
  const buyerId = commonContext.common.buyerId;
  useEffect(() => {
    trackPageAccess(buyerId,window.location.href)
  }, []);
	return (
		<div>
      {/* <div className='uppercase font-bold text-xl'>Click Report</div> <CalendarOutlined className='text-xl' />*/}
			{/* <Divider className='my-3'/> props?.location?.state?.showJobInfeed?.showTab==="f"?"2":"3"*/}
			<Tabs defaultActiveKey={"2"} >
      {props?.location?.state?.showJobInfeed?.showTab==="f"?
      <TabPane
        tab={ <span className='uppercase'><PicCenterOutlined className='text-xl'/>Jobs In Feed</span> }
        key={2}>
          <JobsInFeedBlock/>
      </TabPane>
      :
      <TabPane
        tab={ <span className='uppercase'><RocketOutlined className='text-xl'/>JOBS IN FEED BOOST</span> }
        key={3}
      >
        <JobBoostSupplierContract/>
      </TabPane>}
			<TabPane
        tab={ <span className='uppercase'><PicRightOutlined className='text-xl'/>Jobs Override</span> }
        key={1}
      >
        <JobsOverride/>
      </TabPane>
			</Tabs>
		</div>
	);
};

export default JobsInfeedOverrideTabs;